import { useToast } from '@chakra-ui/react';
import { useQ } from './useQ';
import { fetcher } from '../fetcher';
import { AdminReactorEconomyConfigsEndpoints } from '../endpoints/adminEndpoints';
import { ReactorEconomyConfig } from '@olagg/db-types';
import { ReactorEconomyConfigFormData } from '@olagg/validation-schemas';

// Admin hook for the Reactor credit-production parameters (R_MIN/R_MAX/D_CAP).
// `configs` is the full version history (newest first); `current` is the row
// effective right now. Creating a new version sweeps producing accounts at the
// old params first (handled by the backend), then applies the new ones forward.
export default function useAdminReactorEconomyConfigs() {
  const toast = useToast();

  const { data: listData, mutate: mutateList } = useQ<{
    reactorEconomyConfigs: ReactorEconomyConfig[];
  }>(AdminReactorEconomyConfigsEndpoints.all());

  const { data: currentData, mutate: mutateCurrent } = useQ<{
    reactorEconomyConfig: ReactorEconomyConfig;
  }>(AdminReactorEconomyConfigsEndpoints.current());

  const create = (payload: ReactorEconomyConfigFormData) =>
    fetcher(AdminReactorEconomyConfigsEndpoints.create(payload))
      .then((res) => {
        mutateList();
        mutateCurrent();
        toast({
          title: 'Configuración actualizada',
          colorScheme: 'olaggGreen',
          status: 'success',
          description: 'Se creó una nueva versión de parámetros del Reactor',
          position: 'bottom-right',
          duration: 3000,
          isClosable: true,
        });
        return res;
      })
      .catch((error) => {
        toast({
          title: 'Error',
          colorScheme: 'olaggYellow',
          status: 'error',
          description:
            typeof error?.error === 'string'
              ? error.error
              : 'No se pudo guardar la configuración',
          position: 'bottom-right',
          duration: 4000,
          isClosable: true,
        });
        throw error;
      });

  return {
    configs: listData?.reactorEconomyConfigs ?? [],
    current: currentData?.reactorEconomyConfig,
    create,
    mutate: () => {
      mutateList();
      mutateCurrent();
    },
  };
}
